import React from "react";

import { Link } from "react-router-dom";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    BarChart,
    Bar,
    ComposedChart,
    Label,
} from "recharts";

import { PageHeader, Descriptions, Divider, Row, Col, Button, Table } from "antd";

import { LAYOUT_REPORT_STATS_JOBS_PERIOD } from "../../../navigation";

const columns = [
    {
        title: "Month",
        dataIndex: "name",
        key: "name",
        render: (name, record) => <Link to={LAYOUT_REPORT_STATS_JOBS_PERIOD(record.id)}>{name}</Link>,
    },
    {
        title: "# of Jobs",
        dataIndex: "Jobs",
        key: "Jobs",
    },
    {
        title: "# of Words",
        dataIndex: "Words",
        key: "Words",
    },
];

const Show = (props) => {
    const goBack = () => props.history.goBack();

    const { data } = props;

    return (
        <PageHeader ghost={false} onBack={goBack} title="Jobs" subTitle="Stats">
            <div style={{ width: "100%", height: 500 }}>
                <ResponsiveContainer>
                    <LineChart
                        width={500}
                        height={500}
                        data={data.stats}
                        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <Legend verticalAlign="top" height={36} />
                        <XAxis dataKey="name">
                            <Label value="Months" position="top" />
                        </XAxis>
                        <YAxis
                            yAxisId="left"
                            label={{
                                value: "Jobs",
                                angle: -90,
                                position: "outsideRight",
                                textAnchor: "middle",
                                ffset: 90,
                            }}
                        />
                        <YAxis
                            yAxisId="right"
                            orientation="right"
                            label={{
                                value: "Words",
                                angle: 90,
                                position: "insideRight",
                                textAnchor: "middle",
                                ffset: 90,
                            }}
                        />
                        <Tooltip />
                        <Line yAxisId="right" type="monotone" dataKey="Words" stroke="#82ca9d" />
                        <Line yAxisId="left" type="monotone" dataKey="Jobs" stroke="#8884d8" />
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <Divider />

            <Table dataSource={data.stats || []} columns={columns} size="small" pagination={false} />

            <Divider />
        </PageHeader>
    );
};

export default Show;

/**
    <div style={{ width: '100%', height: 300 }}>

        <ResponsiveContainer>
      <ComposedChart
        width={500}
        height={300}
        data={data.stats}
        margin={{
          top: 20, right: 30, left: 20, bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="pv" stackId="a" fill="#8884d8" />
        <Bar dataKey="uv" stackId="a" fill="#82ca9d" />
            <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
      </ComposedChart>

            </ResponsiveContainer>
        </div>
*/
